import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import AdminInner from "../../../components/layout/admin_inner";
import {Typography} from "@mui/material";

export const AdminMarketingPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/app/admin/marketing/organization");
    }, []);

    return (
        <AdminInner>
            <Typography variant="h4">Módulo de Marketing / CRM</Typography>
        </AdminInner>
    );
};
